import { Storage } from '@ionic/storage'
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';


@Injectable()
export class DataProvider {
		
	playerId;	
	
	avatarId;	
	
    username: string;
    password: string;
	name;
	firstname;

	totalExp;
	level;
	levelExp;
	maxLevelExp;
	levelList;
	
		
	cashType;

	logged;

	deltaTime;

    treflouz: number;
    euro: number;

	WSToken;

	games;
	machine;

	

	trophiesList;
	trophiesCompletedTotal;

	treflouzPacks;
	treflouzPacksNormal;
	treflouzPacksPromo;

	avatarsList;
	unlockedAvatars;
	lockedAvatars;

	lockedElements;

	gatchasList;
	gatchasListCleaned;
	contentGatcha;

	notifAvatar;
	notifShop = false;
	notifMachine = false;
	notifChat = false;

	keyboardShown = false;

	superTabsInstance;

    constructor(public storage: Storage) {
        this.initData();
    }

    initData() {
		
		this.playerId = null;

		this.avatarId = null;
	
		this.username = null;
		this.password = null;
		this.name = null;
		this.firstname = null;
		this.password = null;
		
		this.totalExp = null;
		this.level = null;
		this.levelExp = null;
		this.maxLevelExp = null;
		this.levelList=new Array();
		
		this.cashType = null;
		

		this.logged = false;
		
		this.deltaTime = null;
		
		this.treflouz = null;
        this.euro = null;
		
		this.WSToken = null;
		
		this.games=new Array();
		this.machine=new Array();
		
		
		this.trophiesList=new Array();
		this.trophiesCompletedTotal = null;
		
		this.treflouzPacks=new Array();
		this.treflouzPacksNormal=new Array();
		this.treflouzPacksPromo=new Array();
		
		this.avatarsList=new Array();		
		this.unlockedAvatars=new Array();
		this.lockedAvatars=new Array();
		
		this.lockedElements = new Array();
		
		this.gatchasList = new Array();
		this.gatchasListCleaned = new Array();
		this.contentGatcha = null;
		
		this.notifAvatar = 0;
		this.notifShop = false;
		this.notifMachine = false;
		this.notifChat = false;
		
		this.keyboardShown = false;
    }

    getSavedUserInfos(): Promise<any> { 
        return this.storage.get('userInfos'); 
    }

    save(): void {
        let userInfos = {
            username: this.username,
            password: this.password
        }
        
        let newData = JSON.stringify(userInfos); 
        this.storage.set('userInfos', newData);
    }

    computeExp(): void {
		
		let currentLevel;
		for (var i in this.levelList){
			if (this.levelList[i]._id == this.level){
				currentLevel = this.levelList[i];
			}
		}
		
		this.levelExp = this.totalExp - currentLevel.exp;
		if (currentLevel._id >= this.levelList.length - 1){
			this.maxLevelExp = currentLevel.exp;
		}
		else {
			let currentLevelPlus;
			for (var i in this.levelList){
				if (this.levelList[i]._id == this.level+1){
					currentLevelPlus = this.levelList[i];
				}
			}
			console.log(currentLevelPlus)
			this.maxLevelExp = currentLevelPlus.exp - currentLevel.exp;
		}
	}

	computeLockedElements(){
		this.lockedElements = new Array();
		
		for (var i in this.levelList){
			for (var j in this.levelList[i].items){
				let element = {
					name:this.levelList[i].items[j],
					level:this.levelList[i]._id
				}
				this.lockedElements.push(element);
			}
		}
		
	}

	getLockedElementLevel(element){
		for (var i in this.lockedElements){
			if (this.lockedElements[i].name == element){
				return this.lockedElements[i].level
			}
		}
		return 0;
	}

	computeAvatars(): void {
	
		this.lockedAvatars = new Array();
		this.unlockedAvatars = new Array();
		
		for (var i in this.avatarsList){
			if(!('progress' in this.avatarsList[i])){
				this.avatarsList[i].progress = 0;
			}
			if (this.avatarsList[i].locked && this.avatarsList[i].progress < this.avatarsList[i].fragments){
				this.lockedAvatars.push(this.avatarsList[i]);
			}
			else {
				this.unlockedAvatars.push(this.avatarsList[i]);
			}
		}
		
	}

	computeTrophies(): void {
		this.trophiesCompletedTotal = 0;
		for (var gameId in this.trophiesList){
			this.trophiesList[gameId].trophies = new Array();
			this.trophiesList[gameId].completed = 0;
			for (var j in this.trophiesList[gameId]){
				if (!isNaN(parseInt(j))){
					this.trophiesList[gameId].trophies.push(this.trophiesList[gameId][j]);
					if (this.trophiesList[gameId][j].completed){
						this.trophiesList[gameId].completed++;
						this.trophiesCompletedTotal++;
					}
				}
			}			
		}
	}

	getTrophiesForGame(game) {
		if (game._id in this.trophiesList){
			return this.trophiesList[game._id];
		}
		else {
			return {completed:0, trophies:[], logo:""};
		}
	}

	computeTreflouzPacks() {
		this.treflouzPacksNormal = new Array();
		this.treflouzPacksPromo = new Array();
		for (var i in this.treflouzPacks){
			if (this.treflouzPacks[i].isPromo){
				this.treflouzPacksPromo.push(this.treflouzPacks[i]);
			}
			else {
				this.treflouzPacksNormal.push(this.treflouzPacks[i]);
			}
		}
	}

	computeGatchas(){
		this.gatchasListCleaned = new Array();
		for (var i in this.gatchasList){
			if (this.gatchasList[i] != null){
				this.gatchasList[i].id = i;
				this.gatchasListCleaned.push(this.gatchasList[i]);
			}
		}
	}

	getGame(id){
		for (var i in this.games){
			if (this.games[i]._id == id){
				return this.games[i];
			}
		}
	}

	getNbNotifGames(){
		var cpt = 0;
		for (var i in this.games){
			for (var j in this.games[i].variants){
				if (this.games[i].variants[j].notif){
					 cpt++;
				}
			}
			
		}
		
		return cpt;
	}

	getNbNotifGamesInGame(game){
		var cpt = 0;

		for (var j in game.variants){
			if (game.variants[j].notif){
				 cpt++;
			}
		}
		
		return cpt;
	}
}



// WEBPACK FOOTER //
// ./src/providers/data/data.ts